<template>
  <div class="portlet">
    <div class="portlet-body">
      <b-table
        class="table table-sm table-list table-mobilepro constractions-table"
        :fields="fields"
        :items="constructions"
        stacked="xl"
      >
        <template v-slot:table-busy>
          <TableSpiner />
        </template>
        <template v-slot:cell(name)="data">
          <div class="name">
            <router-link
              v-if="data.item.parent_id !== null && data.item.color !== null"
              :to="'/construction/' + data.item.parent_id"
              class="badge badge-light"
              :class="getPortletClass(data)"
              :style="setPortletCollors(data)"
              >{{ data.item.parent_name }}</router-link
            >
            <span
              v-else-if="
                data.item.parent_id === null && data.item.color !== null
              "
              class="badge badge-light"
              :class="getPortletClass(data)"
              :style="setPortletCollors(data)"
            >
              {{ data.item.parent_name }}
            </span>
            <router-link
              :to="'/construction/' + data.item.id"
              class="badge badge-light"
              >{{ data.item.name }}</router-link
            >
          </div>
          <small>{{ data.item.pur }}</small>
        </template>
        <template v-slot:cell(client)="data">
          <span v-if="data.item.customer !== null">
            <div>{{ data.item.customer.companyname }}</div>
            <small
              >{{ data.item.customer.firstname }}
              {{ data.item.customer.lastname }}</small
            >
          </span>
          <span v-else> - </span>
        </template>
        <template v-slot:cell(status)="data">
          <label :class="classBadge(data)">{{
            statusName(data.item.status)
          }}</label>
        </template>
        <template v-slot:cell(supervisor)="data">
          {{ data.item.manager.firstname }} {{ data.item.manager.lastname }}
        </template>
        <template v-slot:cell(deadline)="data">
          <div v-if="data.item.important_events.length > 0">
            <div
              class="mb-2 text-secondary"
              v-for="important_event in data.item.important_events"
              :key="important_event.label"
            >
              {{ important_event.date }} - {{ important_event.label }}
            </div>
          </div>
          <span class="text-secondary" v-else>-</span>
        </template>
        <template v-slot:cell(start_date)="data">
          {{ data.item.planned_start_date || "-" }}
        </template>
        <template v-slot:cell(end_date)="data">
          {{ data.item.planned_end_date || "-" }}
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { lightenDarkenColor } from "@/services/helpers";

export default {
  name: "ConstructionList",
  props: {
    constructions: Array,
  },
  data() {
    return {
      items: null,
      fields: [
        { key: "name", label: "Nazwa budowy" },
        { key: "client", label: "Klient" },
        { key: "status", label: "Status" },
        { key: "supervisor", label: "Kierownik" },
        { key: "deadline", label: "Deadline", class: "text-danger" },
        { key: "start_date", label: "Planowano od", class: "text-center" },
      ],
      darkenPercent: -40,
    };
  },
  computed: {
    isSubcontractor() {
      return this.getRole === "subcontractor";
    },
    ...mapGetters("user", ["getRole", "hasAccess"]),
    ...mapGetters("app", ["statusName"]),
  },
  mounted() {
    if (this.isSubcontractor === false) {
      this.fields.push({
        key: "end_date",
        label: "Wysłano fakture",
        class: "text-center",
      });
    } else {
      this.fields.splice(2, 1);
    }
  },
  methods: {
    classBadge: function(data) {
      let statusClass = data.item.status;
      // console.log('list ' + statusClass);
      return {
        "badge badge-success": statusClass === "finished",
        "badge badge-primary": statusClass === "in_progress",
        "badge badge-warning ": statusClass === "not_started",
        "badge badge-danger ": statusClass === "not_payment",
        "badge badge-info ": statusClass === "other",
      };
    },
    setPortletCollors: function(data) {
      if (data.item.color) {
        return (
          "--project-color:" +
          data.item.color +
          "; --project-color-darken:" +
          lightenDarkenColor(
            "#" + data.item.color.substring(1),
            this.darkenPercent
          )
        );
      }
      return false;
    },
    getPortletClass: function(data) {
      let classcss = {};
      if (data.item.parent_id === null && data.item.color === null) {
        return classcss;
      }
      if (data.item.parent_id !== null && data.item.color !== null) {
        classcss["project--subproject"] = true;
      }
      if (data.item.parent_id === null && data.item.color !== null) {
        classcss["project--mainproject"] = true;
      }
      return classcss;
    },
  },
};
</script>
